module.exports = __webpack_public_path__ + "img/_112.8c4f03d7.png";